import {
  Card,
  CardBody,
  CardHeader,
  Select,
  SelectItem,
} from "@nextui-org/react";
import FormInput from "../../form/form-input.component";
import FormSelect from "../../form/select.component";
import { weight_units } from "utils/helper/states";
import { useDispatch, useSelector } from "react-redux";
import { selectProduct } from "store/product/product.selector";
import { ChangeEvent } from "react";
import { Product } from "utils/types/products";
import { ProductValidationErrors } from "utils/helper/product-helper";
import { updateCurrentProduct } from "store/product/product.actions";

function ShippingValues({
  errors,
}: {
  errors: ProductValidationErrors | null;
}) {
  const product = useSelector(selectProduct),
    dispatch = useDispatch();
  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch(updateCurrentProduct({ name: name as keyof Product, value }));
  };
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch(updateCurrentProduct({ name: name as keyof Product, value }));
  };
  return (
    <Card className="py-4 lg:px-4 shadow" radius="md">
      <CardHeader className="pb-0 pt-2 px-4 flex-col items-start !z-0">
        <h4 className="font-bold text-large">Shipping</h4>
      </CardHeader>
      <CardBody className="overflow-visible py-4 space-y-2">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <div className="lg:col-span-2">
            <FormInput
              type="number"
              lang="en"
              min="0"
              step="0.01"
              name="weight"
              label={`Weight`}
              placeholder={`Product weight. . .`}
              value={product.weight}
              onChange={handleChange}
              required
              errorMessage={errors?.weight}
            />
          </div>
          <div className="lg:col-span-2">
            <Select
              className="max-w-full pt-3 capitalize"
              label={
                <p className="label-text">
                  Weight Unit <span className="text-red-600">*</span>
                </p>
              }
              placeholder="Select a Weight Unit"
              selectedKeys={
                product.weight_unit == null ? undefined : [product.weight_unit]
              }
              name="weight_unit"
              onChange={handleSelectChange}
              isInvalid={errors?.weight_unit != null}
              errorMessage={errors?.weight_unit}
              labelPlacement="outside"
              variant="bordered"
              classNames={{
                trigger: "border-1 h-12",
                label: "label",
              }}
            >
              {weight_units.map((unit) => (
                <SelectItem key={unit.value} className="capitalize">
                  {unit.label}
                </SelectItem>
              ))}
            </Select>
          </div>
          <FormInput
            type="number"
            lang="en"
            min="0"
            step="0.01"
            value={product.height}
            onChange={handleChange}
            name="height"
            label={`Height (cm)`}
            placeholder={`Height (cm). . .`}
            errorMessage={errors?.height}
            required
          />
          <FormInput
            type="number"
            lang="en"
            min="0"
            value={product.length}
            onChange={handleChange}
            step="0.01"
            name="length"
            label={`Length (cm)`}
            placeholder={`Length (cm). . .`}
            errorMessage={errors?.length}
            required
          />
          <FormInput
            type="number"
            lang="en"
            value={product.width}
            onChange={handleChange}
            min="0"
            step="0.01"
            name="width"
            label={`Width (cm)`}
            className="col-span-2"
            placeholder={`Width (cm). . .`}
            errorMessage={errors?.width}
            required
          />
        </div>
      </CardBody>
    </Card>
  );
}

export default ShippingValues;
